<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.user.list.username') }}:</label>
            <input v-model.lazy="filters.username" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.name') }}:</label>
            <input v-model.lazy="filters['userData.name']" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.surname') }}:</label>
            <input v-model.lazy="filters['userData.surname']" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
export default {
  name: 'UserFiltering',

  data () {
    return {
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        username: '',
        'userData.name': '',
        'userData.surname': '',
        state: 1
      },
      statuses: [],
      loading: false,
      routeName: null
    }
  },

  directives: {
    debounce
  },

  watch: {
    $route (to, from) {
      this.filter()
    },
    filters: {
      deep: true,
      handler () {
        this.$emit('addToSearchParams', this.filters)
      }
    }
  },

  created () {
    this.routeName = this.$route.name
  },

  methods: {
    remoteMethod () {
      // console.log()
    }
  }
}
</script>
